import { Toolbar } from "ngx-editor";

export class AddNewQuestion {
  active: boolean;
  allowCheckAnswer: boolean;
  ansRenderCount: number;
  autoScoring: boolean;
  checkAnswerAttempt: number;
  minScoreIfAttempt: number;
  options: Options[] | MatrixOptions[] = [];
  optionImages: any;
  stems: Stems[] = [];
  penaltyPoints: number;
  correctPoints: number;
  itemId: number;
  questionOrder: number;
  questionSubTypeId: number;
  questionTypeId: number;
  questiondescription: QuestionDescription;
  questionImages: any;
  scoringTypeExactMatch: boolean;
  shuffleOption: boolean;
  shuffleOptions: boolean;
  questiondisplayoptions: string;
}

export class Options {
  answerDescription: OptionDescription;
  answerValid: boolean;
  correctPoints: number;
  arrangeOrder = 0;
  modified: boolean;
  optionId: number;
  selected: boolean;
  styleid: any;
}

export class MatrixOptions {
  answerDescription: OptionDescription;
  answerValid: boolean;
  correctPoints: number;
  modified: boolean;
  optionId: number;
  selected: boolean;
  arrangeOrder: number;
  optionScores: any[] = [];

}

export class Stems {
  stemdescription: StemDescription;
  matrixid: number;
  stemid: number;
  correctPointsforStem: number;
  validchoiceid: number;
  modified: boolean;
  arrangeOrderForStems: number;
}
export class OptionDescription {
  description: string;
  mediaURL: [
    string
  ];
  file_name: any[];
}

export class StemDescription {
  description: string;
  mediaURL: [
    string
  ];
  file_name: any[];
}
export class QuestionDescription {
  description: string;
  mediaURL: [
    string
  ];
  file_name: any[];
}

export class SurveySingleChoice {
  id: number = 0;
  optionId: number;
  answerDescription: OptionDescription;
  answerValid: boolean;
  isDropDownFormat: boolean = false;
  correctPoints: number;
  arrangeOrder: number = 0;
  sequencialLimit: number = 0;
  modified: boolean;
  selected: boolean;
}
export class SurveyStarRating {
  optionId: number;
  arrangeOrder: 0;
  answerDescription: OptionDescription
}

//Match order
export class PromptRequests {
  promptdescription: StemDescription;
  correctpoints: number;
  promptid: number;
  modified: boolean;
  correctresponseid: number;
  arrangeOrderforPrompts: 0;
  resValue:any
}

export class ResponsesRequests {
  responsedescription: StemDescription;
  arrangeOrderforresponses: 0;
  modified: boolean;
  responseid: number
}

export const GlobalToolbarConfig: Toolbar = [
  ['bold', 'italic'],
  ['underline', 'strike'],
  ['code', 'blockquote'],
  ['ordered_list', 'bullet_list'],
  [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
  ['link', 'image'],
  ['text_color', 'background_color'],
  ['align_left', 'align_center', 'align_right', 'align_justify'],
];
